import React from 'react';
import { useSelector } from 'react-redux';
import utils from 'utils';
import { i18n } from 'utils/i18n';
import useActions from 'hooks/useActions';
import { forgotPasswordProfile } from 'actions/profile';
import { isFetchingEndpointSelector } from 'selectors/fetchingSelectors';
import ANALYTICS from 'constants/analytics';
import GMI_SERVICE_PATHS from 'constants/gmiServicePaths';
import TextField from 'components/Form/TextField';
import Button from 'components/Button';
import FormWrapper from '../FormWrapper/FormWrapper';

const ForgotPasswordForm = () => {
  const forgotPasswordAction = useActions(forgotPasswordProfile);
  const isFetchingResetStart = useSelector((state) =>
    isFetchingEndpointSelector(state, { endpoint: 'profile/resetPasswordStart' })
  );

  const handleFormSubmit = (formData) => {
    forgotPasswordAction(formData);
    utils.analytics.interaction(ANALYTICS.UI_BUTTON, ANALYTICS.FORGOT_PASSWORD, ANALYTICS.SUBMIT);
  };

  return (
    <FormWrapper
      handleFormSubmit={handleFormSubmit}
      formTitle={i18n('enrollment_form_account_information')}
      statePath={GMI_SERVICE_PATHS.RESET_PASSWORD_START}
    >
      <div className='form-wrapper__field-row'>
        <TextField
          name='first_name'
          label={i18n('common_first_name')}
          fill
          required
          disabled={isFetchingResetStart}
          autoComplete='first_name'
        />
        <TextField
          name='last_name'
          label={i18n('common_last_name')}
          fill
          required
          disabled={isFetchingResetStart}
          autoComplete='last_name'
        />
      </div>
      <div className='form-wrapper__field-row'>
        <TextField
          name='email'
          label={i18n('enrollment_form_email_address')}
          fill
          required
          disabled={isFetchingResetStart}
          autoComplete='email'
        />
      </div>

      <Button type='submit' className='form-wrapper__submit-button' disabled={isFetchingResetStart}>
        {i18n('common_submit')}
      </Button>
    </FormWrapper>
  );
};

export default ForgotPasswordForm;
